import React, { useState } from 'react';

import { Alert, Button, Form, Input, message, Modal, Typography } from 'antd';
import { passwordFormRules } from 'services';
import { AdminTrainerOverview, updateAdminTrainerPassword } from './api';

type Props = {
  trainer: AdminTrainerOverview;
  visible: boolean;
  hide: () => void;
};

const UpdatePasswordModal: React.FC<Props> = ({ trainer, visible, hide }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string>();

  return (
    <Modal
      title="Set new password"
      open={visible}
      onCancel={hide}
      footer={null}
      width="500px"
    >
      <Typography.Title level={3}>{trainer.username}</Typography.Title>

      {error ? <Alert type="error" showIcon message={error} /> : null}

      <Form
        form={form}
        onFinish={async values => {
          setSaving(true);
          setError(undefined);
          try {
            await updateAdminTrainerPassword(trainer.id, values.password);
            message.success('Trainer password updated.');
          } catch (requestError) {
            setError(
              requestError instanceof Error
                ? requestError.message
                : 'The trainer password could not be updated.',
            );
          } finally {
            setSaving(false);
          }
        }}
      >
        <Form.Item label="Password" name="password" rules={passwordFormRules}>
          <Input.Password />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          loading={saving}
          style={{ marginTop: 16 }}
        >
          Save
        </Button>
      </Form>
    </Modal>
  );
};

export default UpdatePasswordModal;
